import { CustomContainer, Text } from "../../atoms/DependencyHelper";
import Image from "../../atoms/image/image";
import styles from "./IconWithText.module.scss";

const IconWithText = ({
  icon,
  value,
  description,
  className,
  imageClass,
  valueStyle,
  typeStyle,
  descriptionStyle,
}) => {
  return (
    <CustomContainer className={`${styles["detail-container"]} ${className}`}>
      <Image className={`${styles["icon"]} ${imageClass}`} img_path={icon} />
      <CustomContainer
        className={`${styles["description"]} ${descriptionStyle}`}
      >
        <Text className={`${styles["value"]} ${valueStyle}`}>{value}</Text>
        <Text className={`${styles["type"]} ${typeStyle}`}>{description}</Text>
      </CustomContainer>
    </CustomContainer>
  );
};

export default IconWithText;
